import { useEffect, useRef } from 'react';

import { ForwardBanner } from '#/features/request-forwarding';
import { Container } from '#/shared/components/layout/Container';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetActionViewStore } from '#/shared/stores/timesheetActionViewStore';

import { TimesheetActionsContainer } from './TimesheetActionsContainer';
import { TimesheetReviewContainer } from './TimesheetReviewContainer';

export function TimesheetReviewScreen() {
  const actionsContainerRef = useRef<HTMLDivElement>(null);
  const setActionsContainerRef = usePageStateStore(state => state.setActionsContainerRef);

  const setView = useTimesheetActionViewStore(state => state.setView);

  useEffect(() => {
    setActionsContainerRef(actionsContainerRef);
    return () => setActionsContainerRef(null);
  }, [setActionsContainerRef]);

  const handleForwardRequest = () => {
    actionsContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setView('forward');
  };

  const bannerElement = <ForwardBanner onForwardRequest={handleForwardRequest} />;

  return (
    <Container className="flex-1 px-md">
      <div className="block tablet-portrait:hidden pt-16">{bannerElement}</div>
      <div className="-mx-md tablet-portrait:mx-0">
        <div className="flex-1 w-full grid grid-cols-1 tablet-portrait:grid-cols-2 desktop-small:grid-cols-3 tablet-portrait:gap-md">
          <div className="col-span-1 tablet-portrait:col-span-1 desktop-small:col-span-2">
            <TimesheetReviewContainer />
          </div>
          <div className="col-span-1 tablet-portrait:col-span-1 desktop-small:col-span-1">
            <TimesheetActionsContainer actionsContainerRef={actionsContainerRef} />
          </div>
        </div>
      </div>
    </Container>
  );
}
